<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/ZFb19Y/tc-custom/9781504013680.jpg?1708804230063" alt="This image is the cover for the book Calculated Risk"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Calculated Risk
      </h1>
      <p class="bookDescription body article font2">
        <b>A female financial whiz plans the perfect bank heist in this “high-tech, high-stakes” thriller from the #1 international-bestselling author of <i>The Eight</i> (<i>The Washington Post</i>).</b><br/><br/>  Verity Banks is the one of the most powerful women in finance, but she still reports to a man. Her boss not only refuses to implement her security plan to safeguard customers’ deposits, he also sabotages her shot at becoming director of security at the Federal Reserve. Outraged, Verity decides to take revenge by hitting her boss where it will hurt the most: right in his company’s balance sheet. She is about to begin her assault when she hears from the last person she ever expected to see again, Zoltan Tor.<br/>  <br/> A brilliant computer scientist who taught Verity everything she knows, Zoltan will help her if she agrees to an outlandish wager: Which of them can steal $1 billion, invest it to make $30 million in three months, and return it before anyone notices? Verity can use a computer; Zoltan will do it the old-fashioned way. To beat Zoltan at his own game, Verity will risk her fortune, her professional reputation—and her life.<br/>  <br/> This ebook features an illustrated biography of Katherine Neville including rare images from her life and travels.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Katherine Neville
      </h2>
      
      <p class="authorDescription body article">Katherine Neville is the&#160;<I>New York Times</I>&ndash;bestselling and #1 international bestselling author of spellbinding adventure novels. The&#160;<I>Washington Post</I>&#160;called her groundbreaking first novel&#160;<I>The Eight</I>&#160;&ldquo;a feminist answer to&#160;<I>Raiders of the Lost Ark</I>.&rdquo; In a national poll by the noted Spanish newspaper&#160;<I>El Pa&iacute;s</I>, it was voted one of the top ten books of all time. She has written three other novels: the New York Times Notable Book&#160;<I>A Calculated Risk</I>,&#160;<I>The Magic Circle</I>, and&#160;<I>The Fire</I>, the sequel to&#160;<I>The Eight</I>.<BR /> &#160;<BR /> Neville&rsquo;s novels, which have been published in more than eighty countries, have been enriched by her twenty-year career as an international computer executive and consultant, which took her to live in six countries on three continents and twenty-six of the United States. She has also worked as a portrait painter, a commercial photographer, and a model. To learn more, visit her at www.katherineneville.com.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Open Road Integrated Media
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?132a488c